import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from "./context/AuthContext";


let user = localStorage.getItem("user");

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider userData={user}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

